module.exports = __webpack_public_path__ + "img/report-1.aa146764.jpg";